import { flow } from "fp-ts-esm/function";
import { getExtractor } from "../extractor-infra.js";
const nodesAccessor = (node) => Array.isArray(node.nodes) ? node.nodes : [];
const getRootNode = (nodes) => (
  // @ts-expect-error
  Array.isArray(nodes) ? {
    id: "root",
    type: "UNRECOGNIZED",
    nodes
  } : nodes
);
const extract = flow(
  getRootNode,
  getExtractor(nodesAccessor)
);
export {
  extract
};
//# sourceMappingURL=extract-next.js.map
